/* eslint-disable no-console,no-undef,camelcase */
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import {
  fetchApi,
} from "../../../utils/methods";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import isUndefined from "lodash/isUndefined";
import isNull from "lodash/isNull";
import Waiting from "../../Waiting";
import { toast } from "react-toastify";
import {
  Layout,
  Container,
  InputContainer,
  StyledInputV2,
  StyledLabel,
  ButtonContainer,
  EditorContainer,
  CustomCheckBoxButton
} from "../../CreateEvent/style";
import { Main } from "../../AdminTeamCreation/styles";
import {
} from "../../AdminTeamCreation/styles";
import Editor from '../../CKEditor';
import { ImageUrl } from "../../../utils/constants";
import {  closeIcon, RecognitionCloseIcon, UploadHDMIcon, RecognitionTickIcon} from "../../../utils/icons";
import { Border } from "../../Journeys/styles";
import CommonDropdown from "../../common/CommonDropDown/CommonDropdown";
import { EditThemeEvent,OnSiteEventCategories } from '../../../redux/constants/apiConstants';
import { FormHeading } from "../../ChallengeCreationAdmin/ActivityChallengeLaunch/style";
import { ManagerIconContainer } from "../../Manager/styles";
import StepsHeading from "../../../components/RecogntionAdmin/corevalues/stepNames";
import { CommonButtonPopup } from "../../ReportsV2/styles";
import { CommonButtonBorder } from "../../common/commonStyles";
import { ProfileThemesAll } from "../../../redux/constants/apiConstants";
import { http } from "../../../redux/http";
import CommonImageUploader from "../../common/CommonImageUploader/CommonImageUploader";
import Spinner from "../../common/Spinner";
import { featuredMonths } from "../../../../mockData";



class EditThemeEventCategory extends Component {
  constructor() {
    super();
    this.state = {
      title: "",
      url: "",
      time: "",
      description: "",
      imageName: "",
      imgSrc: "",
      classTypeKey: "",
      classCategoryTypeValue: [],
      onSiteCategoryValue: [],  
      selectedValues:[],
      pointValue: "",
      coachId: null,
      buttonstatus: false,
      step: 1,
      so: false,
      showBack:false,
      buttonClickScrollTop:false,
      selectedOndemandCategory: '',
      selectedOnsiteCategory: '',
      selectedOndemandCategoryValue:[],
      so2: false,
      levels:null,
      getCoachData:[],
      so3: false,
      coachName: '',
      charCount:0,
      selectedOption: 0,
      onSiteCategories: [],
      getThemesValue:[],
      selectedTheme: null,
      themeId:null,
      featureMonth:null,
      featureId:null,
    };
  }

  componentDidMount() {
    const { history } = this.props;
    categoryDetails =  history.location?.state; 



    if (!categoryDetails?.video) {
      window.console.warn("No video data found");
      return;
    }
    const selectedCategoryIds = Array.isArray(categoryDetails?.video?.category_tags) ? categoryDetails?.video?.category_tags.map((tag) => tag.category_id) : [];
    const monthObj=  featuredMonths.find((month)=> month.id === categoryDetails?.video?.featured_month);
    window.console.log("monthObj",monthObj)
    this.getThemes();
    this.GetOnsiteCategories();
    this.setState({
      title: categoryDetails?.video?.title || "",
      imgSrc: categoryDetails?.video?.image,
      featureMonth: monthObj ? monthObj.name : "No feature month",  // ✅ only name
      description: categoryDetails?.video?.description || "",
      imageName: categoryDetails?.video?.thumbnail_image || "",
      onSiteCategoryValue: selectedCategoryIds,
      featureId: categoryDetails?.video?.featured_month || null,
    });
    // }
  }

  //   componentDidUpdate() {
  //     if(this.state.buttonClickScrollTop){
  //       window.scrollTo(0,0);
  //       window.setTimeout(() => {
  //         this.setState({ buttonClickScrollTop: false });
  //       }, 2000);
  //     }
  //     const { ondemandEventDetail, isEditCategory } = this.props;
  //     const { getCoachData, coachName, classCategoryTypeValue } = this.state;
  //     if( isEditCategory && ondemandEventDetail?.coach_id && getCoachData.length>0 && !coachName && (ondemandEventDetail.hra_category_id==classCategoryTypeValue)){
  //       const coachData = getCoachData?.find((coach) => coach?.id == ondemandEventDetail?.coach_id);
  //       if(!coachName){
  //         this.setState({coachName:coachData?.name})
  //       }
  //     }
  //   }
  

  getThemes = async () =>{
    const AuthToken = localStorage.getItem('AUTH_TOKEN');
    try {
      const res = await http.get(`${ProfileThemesAll}`, {headers: {AUTHTOKEN: AuthToken}});
      if (res.message) {
        toast.error(res.message);
      }else{
        let data = [{ month_number: 0, theme_text: 'None', month:"" }];
        this.setState({
          // getThemesValue: (res.all_themes)
          getThemesValue: data.concat(res.all_themes)
        })
      }
    }catch(error){
      toast.error(error.message);
    }
  }

  GetOnsiteCategories = async()=>{
    let category_type = "theme"
    let apiUrl = OnSiteEventCategories + "/"  + category_type;
    try{
      const res = await fetchApi(apiUrl, "GET");
      if(res.status === "success"){
        this.setState({
          onSiteCategories:res.data
        })
      }else{
        toast.error(res.message);
      }
    }catch(error){
      toast.error(error)
    }
  }

  
  onSelectThemeType = (selectedItem) => {
    this.setState({
      selectedTheme: selectedItem.month+(selectedItem.month?" - ":"")+ selectedItem.theme_text,
      themeId: selectedItem.month_number,
    });
  };


  onSelectFeatureMonth = (selectedItem) => {
    window.console.log("featureMonth", selectedItem);
    this.setState({
      featureMonth: selectedItem.name,
      featureId: selectedItem.id,
    });
  };

  onChangeInput = (e) => {
    if(e.target.value.charAt(0) !== ' '){
      this.setState({
        [e.target.name]: e.target.value,
      });
    }
  };


  removePhoto = () => {
    this.setState({
      imgSrc: "",
      imageName: "",
    });
  };


  onChange = (baseImage, imageName) => {
    this.setState({
      imgSrc: baseImage,
      imageName: imageName,
    });
  }


  onSelectClass = (name, value, key) => {
    const selectedValues = [...this.state[name]];
  
    if (selectedValues.includes(value)) {
      const index = selectedValues.findIndex((item) => item === value);
      if (index > -1) selectedValues.splice(index, 1);
    } else {
      if (selectedValues.length < 5) {
        selectedValues.push(value);
      }
    }
  
    this.setState({
      [name]: selectedValues,
      classTypeKey: key,
      coachId: null,
      coachName: '',
    });
  };
  

  saveOndemandEvent = () => {
    const {
      title,
      description,
      //   themeId,
      imgSrc,
      onSiteCategoryValue,
      featureId
    } = this.state;
    this.setState({
      buttonstatus: true,
    });

   
    const OndemandEventDetails = {
      title: title,
      image: imgSrc,
      description: description,
      // type_of_events: selectedOption === 0 ? "on-demand" : "onsite",
      type_of_events:  "theme",
      onsite_event_category_id: onSiteCategoryValue,
      //   theme_id: themeId === 0 || !themeId  ? null : themeId,
      featured_month:  featureId,
    };

    this.PostOndemandEvent(OndemandEventDetails);
  };


  PostOndemandEvent = async(payload)=>{
    const { history } = this.props;
    const video = history.location?.state?.video; 
    const templateId = history.location?.state?.templateId; 

    let apiUrl = EditThemeEvent + "/" + video?.id;
    try{
      const res = await fetchApi(apiUrl, "PUT",payload);

      if(res?.status === "success"){
        toast.success(res.data[0]);
        this.props.history.push({
          pathname: `/company/events/library/company-organized/${templateId}`,
          state: "updateData"
        });
        this.setState({
          buttonStatus: false,
        });
      }else{
        toast.error(res.data.message);
        this.setState({
          buttonStatus: false,
        });
      }
    }catch(error){
      toast.error(error);
      this.setState({
        buttonStatus: false,
      });
    }finally{
      this.setState({
        buttonstatus: false,
      });
    }
  }


  checkBase64(image) {
    if(image) {
      let arr = image.split('/');
      if(arr[0] !== 'onsite-event-template-image') {
        return true;
      }
      else {
        return false;
      }
    }
  }
 

  onChangeDescription = (evt) => {
    const newContent = evt.getData();
    const trimmedString = newContent.replace(/\s|&nbsp;/g, "");
    trimmedString.length === 0 ||
    trimmedString.length === 7 ||
    trimmedString === "<p></p><p></p>"
      ? this.setState({ description: "" })
      : this.setState({ description: newContent });
 
    const plainText = newContent.replace(/<[^>]*>/g, "").trim(); 
    const currentLength = plainText.length;
    this.setState({charCount: currentLength});
  };

  updateStep = (value) => {
    this.setState({ step: value, buttonClickScrollTop:true });
  };

  close = () =>(
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_14978_75731"
        style={{maskType: "alpha",}}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={24}
        height={24}
      >
        <rect width={24} height={24} fill="#C4C4C4" />
      </mask>
      <g mask="url(#mask0_14978_75731)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.3605 0.678084C22.6358 -0.0466026 21.4608 -0.0466023 20.7361 0.678084L11.9067 9.50756L3.07795 0.678849C2.4145 0.0154025 1.33884 0.0154032 0.675399 0.678849C0.0119522 1.3423 0.0119521 2.41796 0.675399 3.0814L9.50411 11.9101L0.675642 20.7386C-0.0490441 21.4633 -0.0490441 22.6382 0.675643 23.3629C1.40033 24.0876 2.57528 24.0876 3.29996 23.3629L12.1284 14.5344L20.9577 23.3637C21.6211 24.0271 22.6968 24.0271 23.3602 23.3637C24.0237 22.7002 24.0237 21.6246 23.3602 20.9611L14.531 12.1319L23.3605 3.30241C24.0851 2.57772 24.0851 1.40277 23.3605 0.678084Z"
          fill="#9C9C9C"
        />
      </g>
    </svg>
  )

  redirect=()=>{
    const { history } = this.props;
    const templateId = history.location?.state?.templateId; 
    this.props.history.push({
      pathname: `/company/events/library/company-organized/${templateId}`,
      state: "updateData"
    });

  }
  renderHeading = () => (
    <FormHeading color={"#184A61"}>
      <div className="close-icon" onClick={this.redirect }>
        <ManagerIconContainer isWidth={"32px"}>{RecognitionCloseIcon('#F37A65')}</ManagerIconContainer>
      </div>
      {"Edit Engagement Event"}
    </FormHeading>
  );

      
  stepOneForm = () => {
    const {
      description,
      step,
      charCount,
    } = this.state;

    const { t } = this.props;

    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container  color="#005C87">
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="ondemand"/>
            </div>
            <div className="form">
              <div className="formBody">
                <InputContainer>
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"}>{this.props.t("Title of the Event")}{<span>*</span>}</StyledLabel>
                  <StyledInputV2
                    placeholder={this.props.t("Enter title")}
                    name="title"
                    onChange={this.onChangeInput}
                    value={this.state.title}
                    maxLength="30"
                    style={{background:"white"}}
                    pColor={"#BDBDBD"}
                    color="#184A61"
                    border={"1px solid #BDBDBD"}
                  />
                  <div className="count">{this.state.title?.length}/30 | C</div>
                </InputContainer>

                <Border style={{ background: '#EFEFEF', margin: '20px 0 8px 0px' }} />

                <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" marginb="12px" symbolSize={"14px"}>{this.props.t("Event image")}{<span>*</span>} <span className="subtext">{("(use illustration)")}</span></StyledLabel>
                <CommonImageUploader
                //   imgSrc={this.state.imgSrc}
                  imgSrc={this.checkBase64(this.state.imgSrc) ? this.state.imgSrc : this.state.imgSrc ? `${ImageUrl}/${this.state.imgSrc}` : null}
                  t={t}    
                  closeIcon={closeIcon}
                  UploadIcon={UploadHDMIcon}
                  onImageChange={this.onChange}
                  onRemoveImage={this.removePhoto}
                />
              
                <Border style={{ background: '#EFEFEF', margin: '20px 0 8px 0px' }} />
                <InputContainer  isColorError={charCount > 3000 ? true : false}>
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"}>{this.props.t("About The Event")}{<span>*</span>}</StyledLabel>
                  <EditorContainer>
                    <Editor content={description} onChange={this.onChangeDescription} />
                  </EditorContainer>
                  <div className="char-count">{charCount}/3000 | C</div>
                </InputContainer>
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };

  
 

  stepTwoForm = () => {
    const {
      step,
      onSiteCategories,
      onSiteCategoryValue,
      featureMonth
    } = this.state;

    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container color="#005C87">
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="ondemand" />
            </div>
            <div className="form">
              <div className="formBody">

                <><InputContainer isFlex={"0 0 290px"}>
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"} marginb="12px">
                    {this.props.t("Select category")}
                    {<div className="subDescription">(min 1 & max 5)</div>}
                    {<span>*</span>}
                  </StyledLabel>
                  <div className="radioButtonClassCategoriesV1" >
                    {
                      onSiteCategories?.map((category, index)=>(
                        <div className="labelName" key={category.id}>
                          <CustomCheckBoxButton
                            isSelected={onSiteCategoryValue.includes(onSiteCategories[index].id)}
                            onClick={() => {
                              this.onSelectClass(
                                "onSiteCategoryValue",
                                onSiteCategories[index].id,
                                onSiteCategories[index].category_name
                              );
                              this.setState({
                                selectedOnsiteCategory: onSiteCategories[index].category_name
                              });
                            }}
                            background={"#85c0ea"}
                          >
                            {onSiteCategoryValue.includes(onSiteCategories[index].id) &&  <div>{RecognitionTickIcon()}</div>}
                          </CustomCheckBoxButton>
                          {category.category_name}
                        </div>
                      ))
                    }
                  </div>
                </InputContainer>
                </>

                <Border style={{background:'#EFEFEF',margin:'8px 0px 0px 0px', display:"flex"}}/>

                <CommonDropdown
                  tileContainerStyle={{ width: "100%",padding:"8px 0px 8px 0px" }}
                  dropdownStyle={{ top: "90px" }}
                  labelText={this.props.t("Feature Month")}
                  isRequired={true}
                  dropdownOpen={this.state.so}
                  placeholder={this.props.t("Select Month")}
                  title={
                    featureMonth
                  }
                  id="dropdown-recurring"
                  onClick={() => this.setState({ so: !this.state.so })}
                  data={featuredMonths}
                  onSelect={this.onSelectFeatureMonth}
                  active={featureMonth}
                  itemValue={true}
                  valueIndex={0}
                  onSelectParameter={["name","id"]}
                  dropIcon={true}
                  labelMargin={"0px"}
                  fontSize={"14px"}
                  showWrapText={0}
                />
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };

  render() {
    const {
      title,
      description,
      imgSrc,
      buttonstatus,
      step,
      charCount,
      onSiteCategoryValue,
      featureId
    } = this.state;

    const isDisabled =onSiteCategoryValue.length === 0 || buttonstatus || featureId === null;
    window.console.log("onSiteCategoryValue.length ", onSiteCategoryValue.length );
    window.console.log("featureId ", featureId );

    const { ondemandCategory } = this.props;
    if (isUndefined(ondemandCategory) || isNull(ondemandCategory)) {
      return <Waiting />;
    }
    return (
      <React.Fragment>
        {step === 1 ? this.stepOneForm() : this.stepTwoForm()}
        {step === 1 ? (
          <ButtonContainer>
            <Main>
              <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto" disabled={!title||!imgSrc|| !description || (charCount > 3000)} onClick={!title||!imgSrc|| !description || (charCount > 3000) ? null: () => this.updateStep(2)}>
               Next
              </CommonButtonPopup>
            </Main>
          </ButtonContainer>
        ) : (
          <ButtonContainer>
            <div className="wrapper">

              <CommonButtonBorder width="200px" height="48px"
                onClick={() => this.updateStep(1)}
                margin="auto auto auto 0px">
                 Back
              </CommonButtonBorder>

              <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto" 
                disabled={isDisabled}
                onClick={!buttonstatus ? () => this.saveOndemandEvent() : null}>
                {buttonstatus ? <Spinner color={"#F37A65"}/> : ' Save '}
              </CommonButtonPopup>

              
            </div>
          </ButtonContainer>
        )}
      </React.Fragment>
    );
  }
}

EditThemeEventCategory.propTypes = {
  ondemandCategory: PropTypes.array,
  history: PropTypes.object.isRequired,
  t: PropTypes.func,
  fetchOndemandEventDetailsById: PropTypes.func.isRequired,
  ondemandEventDetail: PropTypes.object,
  isEditCategory: PropTypes.object,
  location: PropTypes.object.isRequired, 
};

const mapStateToProps = (state) => ({
  ondemandEventDetail: state.events.ondemandEventDetail,
  ondemandCategory: state.events.ondemandCategory,
});



export default connect(mapStateToProps)(withTranslation()(EditThemeEventCategory));